<template>
  <div id="app">
    <el-config-provider :locale="locale">
      <router-view v-slot="{ Component }">
          <component :is="Component" />
      </router-view>
    </el-config-provider>
  </div>
</template>
<script >
import { defineComponent } from 'vue'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
export default defineComponent({
  components: {
    ElConfigProvider,
  },
  setup() {
    return {
      locale: zhCn,
    }
  },
})
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

input {
  background-color: rgba(255, 255, 255, 0) !important;
}

input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}

input:-webkit-autofill:focus {
  -webkit-text-fill-color: #333 !important;
}

.unifiedInputBoxWidth {
  width: 200px;
}
.green{
                    color:#43CC9B;
                }
                .red{
                    color:#F03833;
                }
</style>
